// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import Liveblock from './Liveblock'
import consts from './consts'

Vue.config.productionTip = !consts.configs.isDev
Vue.config.debug = consts.configs.isDev
Vue.config.devtools = consts.configs.isDev
Vue.use(VueResource)

var LiveVue = Vue.extend({
  data () {
    return {
      cmsData: JSON.parse(document.getElementById('liveblock').getAttribute('data-live-block')),
      liveData: {}
    }
  }
})

/* eslint-disable no-new */
if (document.getElementById('liveblock')) {
  new LiveVue({
    el: '#liveblock',
    template: '<Liveblock />',
    components: { Liveblock }
  })
}



// WEBPACK FOOTER //
// ./src/main.js